import { z } from 'zod';

/**
 * What a player has achieved on this device: personal bests in Training and the Tutorial
 * chapters done. Cross-save (milestone 5) syncs it, so the schema lives in `shared`. Every
 * field has a default, so older data parses and gains the new fields.
 */

export const TUTORIAL_CHAPTERS = 5;

export const TrainingRecordSchema = z.object({
  /** Fastest solved time, in milliseconds of game time. */
  bestMs: z.number().int().nonnegative(),
  /** Best verdict, 1–3 stars. */
  stars: z.number().int().min(1).max(3),
  plays: z.number().int().nonnegative().default(0),
});
export type TrainingRecord = z.infer<typeof TrainingRecordSchema>;

export const ProgressSchema = z.object({
  /** Keyed by `trainingKey(type, level)`. */
  training: z.record(z.string(), TrainingRecordSchema).default({}),
  /** Tutorial chapters finished, 1-based. */
  tutorial: z
    .array(z.number().int().min(1).max(TUTORIAL_CHAPTERS))
    .default([])
    .transform((c) => [...new Set(c)].sort((a, b) => a - b)),
});
export type Progress = z.infer<typeof ProgressSchema>;

export const trainingKey = (type: string, level: number): string => `${type}:${level}`;
